(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketrealtimeDialogController', TicketrealtimeDialogController);

    TicketrealtimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ticketrealtime'];

    function TicketrealtimeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ticketrealtime) {
        var vm = this;

        vm.ticketrealtime = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketrealtime.id !== null) {
                Ticketrealtime.update(vm.ticketrealtime, onSaveSuccess, onSaveError);
            } else {
                Ticketrealtime.save(vm.ticketrealtime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ticketrealtimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;
        vm.datePickerOpenStatus.fechaproceso = false;
        vm.datePickerOpenStatus.fechaenvio = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
